import { createFiltersActions } from '../utils';

export const ACTIONS_PREFIX = 'REVIEW_LICENSE';

export const {
    updateFilters,
    applyFilters,
    resetApplyFilters,
    resetApplyFiltersSilently,
    rebuildApplyFiltersSilently
} = createFiltersActions(ACTIONS_PREFIX);
